"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var x_date_pickers_1 = require("@mui/x-date-pickers");
var DatePickerInput = function (_a) {
    var error = _a.error, _b = _a.value, value = _b === void 0 ? null : _b, onChange = _a.onChange, _c = _a.inputFormat, inputFormat = _c === void 0 ? 'YYYY/MM/DD' : _c, placeholder = _a.placeholder, textFieldProps = _a.textFieldProps, helperText = _a.helperText, props = __rest(_a, ["error", "value", "onChange", "inputFormat", "placeholder", "textFieldProps", "helperText"]);
    return ((0, jsx_runtime_1.jsx)(x_date_pickers_1.DatePicker, __assign({ value: value, onChange: function (date) {
            onChange(date && date.isValid() ? date.format(inputFormat) : null);
        }, format: inputFormat, slotProps: {
            toolbar: { toolbarFormat: inputFormat },
            desktopPaper: {
                sx: {
                    //hidden select date text on desktop
                    '& .MuiPickersToolbar-root > .MuiTypography-root': {
                        display: 'none',
                    },
                },
            },
            dialog: {
                sx: {
                    //hidden select date text on mobile
                    '& .MuiPickersToolbar-root > .MuiTypography-root': {
                        display: 'none',
                    },
                },
            },
            textField: __assign(__assign({ error: !!error, helperText: (error === null || error === void 0 ? void 0 : error.message) || ' ' }, textFieldProps), { inputProps: __assign(__assign({}, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.inputProps), { placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : inputFormat }) }),
        } }, props)));
};
exports.DatePickerInput = DatePickerInput;
